import { Controller } from "@hotwired/stimulus";

// File-browser style selection for Message Sets: expand/collapse folders, click set to select.
export default class extends Controller {
  static targets = ["hidden"];
  static values = {
    useTemplateId: { type: Boolean, default: false },
  };

  connect() {
    this.markSelectedRow();
  }

  selectSet(event) {
    const row = event.currentTarget.closest(".set-row");
    if (!row) return;
    const id = this.useTemplateIdValue
      ? row.dataset.rootTemplateId
      : row.dataset.setId;
    if (!id) return;

    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = id;
    }
    this.clearSelectionStyles();
    this.applySelectionStyle(row);
  }

  markSelectedRow() {
    if (!this.hasHiddenTarget) return;
    const id = this.hiddenTarget.value;
    if (!id) return;
    const selector = this.useTemplateIdValue
      ? `.set-row[data-root-template-id="${id}"]`
      : `.set-row[data-set-id="${id}"]`;
    const row = this.element.querySelector(selector);
    if (row) this.applySelectionStyle(row);
  }

  clearSelectionStyles() {
    this.element.querySelectorAll(".set-row").forEach((el) => {
      el.removeAttribute("data-selected");
      el.style.backgroundColor = "";
      el.style.outline = "";
      el.style.outlineOffset = "";
    });
  }

  applySelectionStyle(row) {
    row.setAttribute("data-selected", "true");
    row.style.backgroundColor = "rgb(239 246 255)";
    row.style.outline = "2px solid rgb(96 165 250)";
    row.style.outlineOffset = "2px";
  }
}
